export const SET_WALLET_DATA = "SET_WALLET_DATA";
export const SET_ALL = "SET_ALL";
export const SET_RECEIVEDS = "SET_RECEIVEDS";
export const SET_SENDEDS = "SET_SENDEDS";
export const REMOVE_TICKET_DATA = "REMOVE_TICKET_DATA";
export const CURRENT_PAGE = "CURRENT_PAGE";
export const SET_TOTAL_RESOURCES = "SET_TOTAL_RESOURCES";
export const LIMIT_OPTIONS = "LIMIT_OPTIONS";
export const LIMIT = "LIMIT";
export const LOADING_DATA = "LOADING_DATA";
export const WITHDRAW = "WITHDRAW";
export const WITHDRAW_SUCCESS = "WITHDRAW_SUCCESS";
export const WITHDRAW_ERROR = "WITHDRAW_ERROR";
export const WITHDRAW_ERROR_MESSAGE = "WITHDRAW_ERROR_MESSAGE";
export const NOTIFICATION_BAR = "NOTIFICATION_BAR";
export const SHOW_FILTERS = "SHOW_FILTERS";
export const FILTER_PARAMS = "FILTER_PARAMS";
export const SET_URL_BILL = "SET_URL_BILL";
export const SET_BILL_ERROS = "SET_BILL_ERROS";
export const SET_BILL_PAYMENT = "SET_BILL_PAYMENT";
export const SHOW_BILL_PAYMENT = "SHOW_BILL_PAYMENT";
export const SHOW_BILL_PAYMENTS = "SHOW_BILL_PAYMENTS";
export const SET_BILL_PAYMENT_ERRORS = "SET_BILL_PAYMENT_ERRORS";
export const SET_BILL_RESOURCES = "SET_BILL_RESOURCES";
export const SET_BILL_RESOURCES_COUNT = "SET_BILL_RESOURCES_COUNT";
export const SET_BILL_LOADING_DATA = "SET_BILL_LOADING_DATA";
export const SET_BILL_CURRENT_PAGE = "SET_BILL_CURRENT_PAGE";
export const SET_BILL_LIMIT = "SET_BILL_LIMIT";
export const SET_BILL_PAYMENT_RESOURCES = "SET_BILL_PAYMENT_RESOURCES";
export const SET_BILL_PAYMENT_RESOURCES_COUNT = "SET_BILL_PAYMENT_RESOURCES_COUNT";
export const SET_BILL_PAYMENT_LOADING_DATA = "SET_BILL_PAYMENT_LOADING_DATA";
export const SET_BILL_PAYMENT_CURRENT_PAGE = "SET_BILL_PAYMENT_CURRENT_PAGE";
export const SET_BILL_PAYMENT_LIMIT = "SET_BILL_PAYMENT_LIMIT";
export const ORDINATION = "ORDINATION";

export const SET_FILTER_ID = "SET_FILTER_ID";
export const SET_FILTER_TYPE_NAME = "SET_FILTER_TYPE_NAME";
export const SET_FILTER_POSITIVE = "SET_FILTER_POSITIVE";
export const SET_FILTER_TYPE_ID = "SET_FILTER_TYPE_ID";
export const SET_FILTER_KIND = "SET_FILTER_KIND";
export const SET_FILTER_TYPE_AMOUNT = "SET_FILTER_TYPE_AMOUNT";
export const SET_FILTER_INITIAL_DATE = "SET_FILTER_INITIAL_DATE";
export const SET_FILTER_FINAL_DATE = "SET_FILTER_FINAL_DATE";
export const FILTER_INITIAL_DATE = "FILTER_INITIAL_DATE";
export const FILTER_FINAL_DATE = "FILTER_FINAL_DATE";
export const FILTER_ORDER = "FILTER_ORDER";

export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
export const SET_FILTER_STATUS = "SET_FILTER_STATUS";
export const SET_FILTER_PAYER_NAME = "SET_FILTER_PAYER_NAME";
export const SET_FILTER_AMOUNT = "SET_FILTER_AMOUNT";

// DARF Payment Types
export const SET_DARF_PAYMENT = "SET_DARF_PAYMENT";
export const SHOW_DARF_PAYMENT = "SHOW_DARF_PAYMENT";
export const SET_DARF_PAYMENT_ERRORS = "SET_DARF_PAYMENT_ERRORS";
export const SET_DARF_PAYMENT_LOADING_DATA = "SET_DARF_PAYMENT_LOADING_DATA";
export const SET_DARFS_PAYMENT_RESOURCES = "SET_DARFS_PAYMENT_RESOURCES";
export const SET_DARFS_PAYMENT_RESOURCES_COUNT = "SET_DARFS_PAYMENT_RESOURCES_COUNT";
export const SET_DARFS_PAYMENT_LOADING_DATA = "SET_DARFS_PAYMENT_LOADING_DATA";
export const SET_DARFS_PAYMENT_CURRENT_PAGE = "SET_DARFS_PAYMENT_CURRENT_PAGE";
export const SET_DARFS_PAYMENT_LIMIT = "SET_DARFS_PAYMENT_LIMIT";

// PIX Payment Types
export const SET_PIX_PAYMENT = "SET_PIX_PAYMENT";
export const SHOW_PIX_PAYMENT = "SHOW_PIX_PAYMENT";
export const SET_PIX_PAYMENT_ERRORS = "SET_PIX_PAYMENT_ERRORS";
export const SET_PIX_PAYMENT_LOADING_DATA = "SET_PIX_PAYMENT_LOADING_DATA";
export const SET_PIX_PAYMENT_RESOURCES = "SET_PIX_PAYMENT_RESOURCES";
export const SET_PIX_PAYMENT_RESOURCES_COUNT = "SET_PIX_PAYMENT_RESOURCES_COUNT";
